module.exports = __webpack_public_path__ + "img/INF-A-2-I.67aca158.png";